<template>
<div class="learner min-h-screen ">
    <alert v-model="notify.show" :errorType="notify.type" :message="notify.message" />
    <update-password @notify="handleNotify($event)" v-model="showPasswordModal" />
    <rate-course @notify="handleNotify($event)" v-model="showRatingModal" />
    <update-profile @notify="handleNotify($event)" v-model="showUpdateProfileModal" />
    <div class="flex flex-row min-h-screen w-full">
        <nav-bar v-if="!showNav" class="fixed" />
        <div class="w-full ">
            <div class=" top-0 z-10">
                <top-bar @toggle-nav="showNav = true" />
            </div>
            <div style="background-color: #f5f3f3 !important" class="min-h-screen">
                <div class="main mx-4 py-4 flex-grow">
                    <router-view :key="$route.fullPath" @notify="handleNotify($event)" @update-password-modal="showPasswordModal = true" @update-profile-modal="showUpdateProfileModal = true" @rate-course="showRatingModal = true" />
                </div>
            </div>
        </div>
    </div>
    <a href="#" class="float" @click="showForm">
        <i class="fa fa-envelope my-float"></i>
    </a>
    <modal @click="hide" :name="'contact-form'" :width="400" :height="400" :adaptive="true">
        <h2 class="text-center mt-4 font-bold">TNY Email Support</h2>
        <p class="m-4">Hi! Do you need assistance or have any issues?</p>
        <p>Send us a message and we will reply</p>

        <div class="container mx-auto ml-10  mt-10">
            <div class="w-full max-w-xs">

                <div class="mb-4" style="display:flex; justify-content:center">

                    <textarea rows="7" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" v-model="contactFormData.message" placeholder="Tell us about the issue..."></textarea>
                </div>

                <div class="flex items-center justify-center">
                    <button @click="sendMail" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
                        {{button_text}}
                    </button>

                </div>
            </div>
        </div>
    </modal>
    <div v-show="showNav" class="lg:hidden mobile-side fixed w-full min-h-screen  top-0">
        <div class="bg-red-900 min-h-screen  w-full" style="background: rgba(11, 133, 228, 0.5);">
            <div @click.prevent="showNav = false" class="mobile-menu min-h-screen w-3/5">
                <div class="mx-2 py-2">
                    <div @click.prevent="showNav = false" class="cursor-pointer text-white mb-12">
                        <i class="fas fa-times fa-3x"></i>
                    </div>
                    <div class="text-white">
                        <div id="learner_mobile_dashboard" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath == '/learner' }" to="/learner">
                                <i class="fas fa-home mr-4 mt-1"></i>
                                <span>Dashboard</span>
                            </router-link>
                        </div>
                        <!-- <div id="learner_mobile_programs" class="mx-6 my-8">
                            <router-link class="nav-item " :class="{ active: activePath.match('/learner/programs') }" to="/learner/programs">
                                <span class=""></span>
                                <i class="fas fa-layer-group mr-4 mt-1"></i>
                                <span>Programs </span>
                            </router-link>
                        </div> -->
<!--                        <div id="learner_mobile_courses" class="mx-6 my-8">-->
<!--                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/course') }" to="/learner/courses">-->
<!--                                <span class=""></span>-->
<!--                                <i class="fab fa-discourse mr-4 mt-1"></i>-->
<!--                                <span>Courses </span>-->
<!--                            </router-link>-->
<!--                        </div>-->
                        <div id="learner_mobile_courses_mine" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/my-courses') }" :to="{ name: 'learner-enrolled-courses' }">
                                <span class=""></span>
                                <i class="fab fa-leanpub mr-4 mt-1"></i>
                                <span>My Courses </span>
                            </router-link>
                        </div>

                        <!-- <div id="learner_mobile_webinar" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/webinar') }" to="/learner/webinar">
                                <span class=""></span>
                                <i class="fas fa-play-circle mr-4 mt-1"></i>
                                <span>Webinar </span>
                            </router-link>
                        </div>

                        <div id="learner_mobile_board" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/discussion') }" class="nav-item" :to="{ name: 'learner-discussion-home' }">
                                <i class="fas fa-comments mr-4 mt-1"></i>
                                <span>Discussion Boards</span>
                            </router-link>
                        </div>
                        <div id="learner_mobile_todo" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/todo') }" class="nav-item" :to="{ name: 'learner-todo-home' }">
                                <i class="fas fa-list-ol mr-4 mt-1"></i>
                                <span>To do Lists</span>
                            </router-link>
                        </div> -->

                        <div id="learner_mobile_journal" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/notes') }" class="nav-item" :to="{ name: 'learner-notes-home' }">
                                <i class="far fa-sticky-note mr-4 mt-1"></i>
                                <span>Learning Journal</span>
                            </router-link>
                        </div>
                        <div id="learner_web_growth_plan" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/growth_plan') }" class="nav-item" :to="{ name: 'learner-growthplan-home' }">
                                <i class="fa fa-chart-line mr-4 mt-1"></i>
                                <span> Growth Plans</span>
                            </router-link>
                        </div>

                        <!-- <div id="learner_mobile_submissions" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/submissions') }" to="/learner/submissions">
                                <span class=""></span>
                                <i class="fab fa-discourse mr-4 mt-1"></i>
                                <span>Submissions </span>
                            </router-link>
                        </div>

                        <div id="learner_mobile_leaderboard" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/leaderboard/') }" :to="{ name: 'learner-leaderboard-home' }">
                                <i class="fas fa-poll mr-4 mt-1"></i>
                                <span>Leaderboard</span>
                            </router-link>
                        </div> -->
                        <div id="learner_mobile_completion" class="mx-6 my-8">
                            <router-link class="nav-item" :class="{ active: activePath.match('/learner/completion/') }" to="/learner/completion">
                                <i class="fas fa-poll mr-4 mt-1"></i>
                                <span>Completion</span>
                            </router-link>
                        </div>
                        <!-- <div id="learner_mobile_notification_settings" class="mx-6 my-8">
                            <router-link class="nav-item" :to="{ name: 'learner-notification-settings' }">
                                <span><i class="fas fa-bell-slash mr-4"></i></span>
                                <span>Notification Settings</span>
                            </router-link>
                        </div>
                        <div id="learner_mobile_cart" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/cart') }" class="nav-item" :to="{ name: 'learner-cart' }">
                                <i class="fas fa-cart-plus mr-4 mt-1"></i>
                                <span>Cart</span>
                            </router-link>
                        </div>
                        <div id="learner_mobile_wishlist" class="mx-6 my-8">
                            <router-link :class="{ active: activePath.match('/learner/wishlist') }" class="nav-item" :to="{ name: 'learner-wishlist' }">
                                <i class="fas fa-list-ol mr-4 mt-1"></i>
                                <span>Wishlist</span>
                            </router-link>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <modal name="logout" width="400" height="400" :adaptive="true">
        <h2 class="text-center mt-4 font-bold">EDCLEARN SUPPORTss</h2>
        <p class="text-center m-4">do you need assistance or have any suggestions, kindly let us know</p>

        <div class="container mx-auto ml-10  mt-10">
            <div class="w-full max-w-xs">

                {{ timer }}
            </div>
        </div>
    </modal> -->
</div>
</template>

<script>
import moment from "moment";
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
// import firebase from "@/firebaseConfig.js";
// import {
//     initializeFirebase
// } from "@/push-notification";
// const {
//     messaging
// } = firebase;

export default {
    data() {
        return {
            showProgramModal: false,
            showCourseModal: false,
            showTenantModal: false,
            showModuleModal: false,
            showLessonModal: false,
            showPasswordModal: false,
            showUpdateProfileModal: false,
            showRatingModal: false,
            timer:5,
            alert: false,
            showNav: false,
            notify: {
                type: null,
                show: false,
                message: "",
            },
            contactFormData: {
                name: '',
                email: '',
                message: '',
            },
            button_text: 'Send Message',
            incentiveMessage: '',
            LMSUserItem: JSON.parse(localStorage.getItem("lms-user")),
        };
    },
    components: {
        TopBar: () => import("@/components/learner/topbar"),
        NavBar: () => import("@/components/learner/Nav"),
        Alert: () => import("@/components/tenant/alert"),
        UpdatePassword: () => import("@/components/shared/password"),
        UpdateProfile: () => import("@/components/learner/update-profile"),
        RateCourse: () => import("@/components/learner/rate_course"),
    },
    computed: {
        ...mapGetters(["getUser", "getToken", "getThemeColor", "getPrefix", "getSettings","getSubscribedCourses"]),

        activePath() {
            return this.$route.path;
        },
        matcher() {
            return this.$route.matched.some((item) => item == "user");
        },

        getCourseWeek(){
          return 20;
        },
        getCoursesCompleted(){
          return 5;
        },
    },
    methods: {
        ...mapActions([
            "fetchTenantSettings",
            "learnerSubscribedCourses",
            "fetchWishlist",
            "updateToken",
            "fetchCart",
            "fetchProfile",
            "sendSupportEmail",
            "getTracker",
            "getWeeklyTnyPerformanceMessage",
            'logout',
            "updateProfile"
        ]),
          ...mapMutations(["updateLoader"]),
        showForm() {
            this.$modal.show("contact-form");
        },
        hide() {
            this.$modal.hide("contact-form");
        },
        async updateUserPermission(permission) {

            //console.log('updating perm...')

            let profile = {
                user_config: JSON.stringify({
                    "data_permissions": permission,
                    "sample_field": "yes"
                })
            };
            let res = await this.updateProfile(profile);

            console.log(res)

            if (res.status == 200) {
                this.$emit("notify", {
                    type: "success",
                    message: "Data Permission Updated",
                });

            } else {
                if (res.status == 400) {
                    this.$Bus.$emit("notify", {
                        type: "error",
                        message: res.data.errors ?
                            res.data.errors[0].title : "An error occured",
                    });
                }
            }

        },
        async sendMail() {
            this.button_text = 'Loading...'
            this.contactFormData.email = this.getUser.email
            this.contactFormData.name = this.getUser.first_name + ' ' + this.getUser.last_name
            let res = await this.sendSupportEmail(this.contactFormData);
            if (res) {
                this.button_text = 'Send Message'
                this.$modal.hide("contact-form");
                this.contactFormData = {}
            } else {
                this.button_text = 'Retry Sending Message'
                this.$modal.hide("contact-form");
                this.contactFormData = {}
            }
        },
        notificationsPermisionRequest() {
            messaging
                .requestPermission()
                .then(() => {
                    messaging
                        .getToken()
                        .then((token) => {
                            if (token) {
                                const currentMessageToken = window.localStorage.getItem(
                                    "messagingToken"
                                );
                                //console.log({ token });
                                this.updateToken({
                                    token
                                });
                                if (currentMessageToken != token) {
                                    window.localStorage.setItem("messagingToken", token);
                                    this.updateToken({
                                        token
                                    });
                                }
                            } else {
                                console.log(
                                    "No InstanceId token available. Request Permission to generate one"
                                );
                                this.notificatioPermissionRequest();
                            }
                        })
                        .catch((err) => {
                            //console.log(err);
                        });
                })
                .catch((err) => {
                    //console.log("Unable to get permission to notify.", err);
                });
        },
        listenTokenRefresh() {
            const currentMessageToken = window.localStorage.getItem("messagingToken");
            if (!!currentMessageToken || currentMessageToken == null) {
                messaging.onTokenRefresh(function () {
                    messaging
                        .getToken()
                        .then(function (token) {
                            this.saveToken({
                                token
                            });
                        })
                        .catch(function (err) {
                            //console.log("Unable to retrieve refreshed token ", err);
                        });
                });
            }
        },
        async saveToken(payload) {
            try {
                window.localStorage.setItem("messagingToken", payload.token);
                this.updateToken({
                    token: payload.token
                });
                //console.log({ payload });
            } catch (err) {
                //console.log(err);
            }
        },
        getMessagingToken() {
            messaging
                .getToken()
                .then((token) => {
                    if (token) {
                        const currentMessageToken = window.localStorage.getItem(
                            "messagingToken"
                        );
                        if (currentMessageToken != token) {
                            // dispatch("saveToken", { token });
                        }
                    } else {
                        console.log(
                            "No InstanceId token available. Request Permission to generate one"
                        );
                        this.notificatioPermissionRequest();
                    }
                })
                .catch((err) => {
                    //console.log(err);
                });
        },
        stringToHtmlConverter (str) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(str, 'text/html');
        return doc.body;
      },
        handleNotify(payload) {
            this.notify.show = true;
            this.notify.type = payload.type;
            this.notify.message = payload.message;
        },
        showLogoutModal(){
            this.$modal.show("logout");
        },

        async showIncentiveModal(){
          const res = await this.getWeeklyTnyPerformanceMessage({
            learner_id : this.getUser.id
          })
          if(res.status === 200){
            this.incentiveMessage = res.data.data.message
          }
           this.$Bus.$on('learner-login', async ()=> {
            let messageBody  = this.incentiveMessage;
            await this.$swal({
              title: '<strong>TNY Incentive</strong>',
              icon: 'info',
              html: this.stringToHtmlConverter(messageBody),
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText:
                  'Ok',
            })

          })
        },
        browserQuestion(){
            let question = JSON.parse(localStorage.getItem('has_browser_question'));

            // this.$modal.show("logout");
            if(question){

                if(question.answer == 'local'){
                    let date1 = moment();

                    if(date1.diff(question.created,'h') === 24) {
                        let timerInterval;
                        // let timerL = this.timer;
                        this.$swal({
                            title: '<strong>Browser Security</strong>',
                            icon: 'info',
                            timer: 5000,
                            timerProgressBar: true,
                            html:'Logging you out in <b></b> seconds',
                            onOpen: (result) => {

                                Vue.swal.showLoading()
                                console.log(this.timer)
                                console.log(result.querySelector('div'))
                                const content = result.querySelector('b')
                                    console.log(content)
                                    // content.textContent = timerL

                            },
                            onClose: () => {
                                clearInterval(timerInterval)
                            }
                        })


                        const interval = setInterval(() => {
                            if(this.timer == 0){
                                clearInterval(interval)
                                this.logout();
            //
                                this.$store.state.learner.courses = {};
                                this.$store.state.learner.cart = {};
                                this.$store.state.learner.wishlist = [];
                                this.$store.state.learner.cartTotal = {};
                                this.$store.state.learner.learner_new_course = {};
                                // localStorage.clear();
                                this.$router.push("/tenant/login");
                                // this.$modal.hide('logout');
                            }
                            console.log(this.timer--);
                        },1000)
                    }
                }else if(question.answer == 'personal'){
                    let date1 = moment();
                    if(date1.diff(question.created,'days') === 14) {
                        let timerInterval;
                        this.$swal({
                            title: '<strong>Browser Question</strong>',
                            icon: 'info',
                            timer: 5000,
                            timerProgressBar: true,
                            html:'Logging you out in <b></b> seconds',
                            didOpen: () => {
                                Swal.showLoading()
                                timerInterval = setInterval(() => {
                                const content = Swal.getContent()
                                this.logout();
            //
                                this.$store.state.learner.courses = {};
                                this.$store.state.learner.cart = {};
                                this.$store.state.learner.wishlist = [];
                                this.$store.state.learner.cartTotal = {};
                                this.$store.state.learner.learner_new_course = {};
                                localStorage.clear();
                                this.$router.push("/tenant/login");
                                console.log(content)
                                if (content) {
                                    const b = content.querySelector('b')
                                    if (b) {
                                    b.textContent = Swal.getTimerLeft()
                                    }
                                }
                                }, 1000)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                            }
                        })

                    }
                }
                // setTimeout(() => {
                //     localStorage.removeItem('has_browser_question');
                // },2000)
            }else {
                this.$swal({
                    title: '<strong>Browser Security</strong>',
                    icon: 'info',
                    html:
                        'Is this your Personal computer or a Public computer (e.g. Cafe)? <br><br>' + 'For Personal computers, we would keep you logged in for two weeks (to ease learning) <br> For Public computers (belonging to a cafe or a friend) we would keep you logged in for just 24hours and automatically log you out',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        'Personal',
                    cancelButtonText:'Public'
                }).then((result) => {
                    let data = {
                        answer: '',
                        created: new Date()
                    };
                    if(result.isDismissed){
                        data.answer =  'local';
                    }
                    if(result.isConfirmed){
                        data.answer =  'personal';
                    }
                    localStorage.setItem('has_browser_question',JSON.stringify(data));
                    console.log(data)
                })
            }
        },
        tnyDataPermission() {
            let user_config = false;

            if (this.LMSUserItem.user_config !== null) {
                try {
                    let config = JSON.parse(this.LMSUserItem.user_config);
                    user_config = (config.data_permissions == "true" || config.data_permissions == true);
                } catch(e) {
                    user_config = (this.LMSUserItem.user_config.data_permissions == "true" || this.LMSUserItem.user_config.data_permissions == true);
                }
            }

            if (localStorage.getItem("has_user_data_permission") !== null && localStorage.getItem("has_user_data_permission") == true) {
                user_config = true;
            }

            if (!user_config) {
                this.$swal({
                    title: '<strong>TNY Data Protection and Consent</strong>',
                    icon: 'info',
                    html:
                        'The Enterprise Development Centre (EDC) is committed to looking after any information that is made available to us when you register on our website. The personal information we collect such as email, phone number and business details are only used for training, learning support and evaluation purposes.<br><br>' +
                        'Please note that your decision to Accept or Reject means that you have read and understood the information contained in our ' +
                        '<a target="_blank" style="color:#0000FF" href="https://edcspaces.nyc3.cdn.digitaloceanspaces.com/Updated%20consent%20form%20for%20TNY.pdf"> Consent Information</a> ',
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    //showDenyButton: true,
                    focusConfirm: true,
                    confirmButtonText: 'Accept',
                    cancelButtonText: 'Reject',
                    //denyButtonText:'Reject',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then((result) => {
                    let user_permission;
                    if (result.isDismissed) {
                        user_permission = false;
                        this.updateUserPermission(user_permission);
                        localStorage.setItem('has_user_data_permission', user_permission);
                    }
                    if (result.isDenied){
                        user_permission = false;
                        this.updateUserPermission(user_permission);
                        localStorage.setItem('has_user_data_permission', user_permission);
                    }
                    if (result.isConfirmed){
                        user_permission = true;
                        this.updateUserPermission(user_permission);
                        localStorage.setItem('has_user_data_permission', user_permission);
                    }
                })
            }
        }
    },
    async mounted() {

        if (this.$store.state.auth.token === "") {
            this.$swal({
                title: "You Are Logged out.. Kindly Login ",
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "login"
                    });
                }
            });
        }
        this.$Bus.$on("notify", (data) => {
            this.notify.show = true;
            this.notify.type = data.type;
            this.notify.message = data.message;
        });

        this.$Bus.$on("rate-course", (data) => {
            this.showRatingModal = true;
        });
        this.$Bus.$on("update-password", (data) => {
            this.showPasswordModal = true;
        });

        this.$Bus.$on("show-learner-sidenav", () => {
            this.showNav = true;
        });

        //console.log({ firebase });
        //console.log({ messaging: firebase.messaging });

        try {
            //initializeFirebase();
        } catch (e) {}
        // Notification.requestPermission().then(function (permission) {
        //     //console.log({ permission });
        // });
        // this.notificationsPermisionRequest();
        // if (Notification.permission !== "allow") {
        //     if (Object.entries(messaging).length > 0) {
        //         this.notificationsPermisionRequest();
        //     }
        // }
        // if (Object.entries(messaging).length > 0) {
        //     this.listenTokenRefresh();
        // }
    },
    async created() {
      try {
        // if (this.LMSUserItem.default_program == "4f1b9237-da53-4812-be86-841bee6a8971") {
        //     await this.showIncentiveModal();
        // }
        await this.browserQuestion();

        //console.log(this.LMSUserItem)

        //if (this.LMSUserItem.id == "b230aac6-99c6-4516-b01b-39184010bbc9") {
        if (this.LMSUserItem.default_program == "4f1b9237-da53-4812-be86-841bee6a8971") {
            //console.log('processing data permission')
            await this.tnyDataPermission();
        }
        

        setInterval(() => {
           this.fetchTenantSettings({
               prefix: this.getPrefix,
           });
       }, 900000); // run every 15mins

        if (this.getThemeColor) {
            document.documentElement.style.setProperty(
                "--lms-tenant",
                `${this.getThemeColor}`
            );
        }
        let res = this.getUser;

        if (res.gender === null ) {
          this.$swal({
            title: "Please Kindly Update Your Gender",
            confirmButtonText: "Update Profile Settings",
            showCancelButton: false,
          }).then((res) => {
            if (res.isConfirmed) {
              this.$router.push('/learner/settings');
            }

          });
        }
        if (res.phone_number === null && !this.getSettings.data_bypass) {
            this.$swal({
                title: "Please Kindly Update Your Phone Number To Receive SMS Reminders",
                confirmButtonText: "Update Phone Number",
                showCancelButton: false,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push('/learner/settings');
                }

            });
        }
        else if (!res.phone_number_data_verified && this.getSettings.data_bypass) {
            // this.$swal({
            //     title: "To be able to learn with network data assistance (on a Mobile Device), kindly specify the phone number here",
            //     confirmButtonText: "Update Phone Number",
            //     showCancelButton: false,
            // }).then((res) => {
            //     if (res.isConfirmed) {
            //         this.$router.push('/learner/settings?initial=true').catch(()=>{});
            //     }

            // });
        }
      }
      catch(err){
        console.log(err);
      }

    },
};
</script>

<style lang="scss">
.learner {
    .main {

        // styles for the main body of the admin section
        .heading {
            background-color: color(lms-tenant);
        }

        .page {
            font-size: 32px;
            font-weight: 600;
        }
    }

    .lesson {
        background-color: #fff;
    }

    .topbar {
        background-color: #fff;
        color: #2e3a6e;

        .right {
            div {
                margin-right: 25px;
                color: color(lms-admin);
            }
        }
    }

    .sidebar {
        background-color: color(lms-tenant);

        a {
            display: flex;
            flex-direction: row;
            padding: 1.25rem;
            cursor: pointer;
            color: #fff;

            &.active {
                background-color: #fff !important;
                color: black;
            }
        }
    }

    .text-tenant-color {
        color: color(lms-tenant);
    }

    .tenant-border {
        border-color: color(lms-tenant);
    }

    .mobile-menu {
        background-color: color(lms-tenant);
        width: 230px;
    }

    .page {
        font-size: 32px;
        font-weight: 600;
    }

    .mobile-side {
        height: 200px;
        overflow-y: auto;
    }
}

.float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 40px;
    background-color: color(lms-tenant);
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    box-shadow: 2px 2px 3px #999;
}

.my-float {
    font-size: 24px;
    margin-top: 18px;
}

a.float+div.label-container {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s ease;
}

a.float:hover+div.label-container {
    visibility: visible;
    opacity: 1;
}
</style>
